import { render, staticRenderFns } from "./erikoistujien-seuranta-virkailija-card.vue?vue&type=template&id=e7e8897a&scoped=true&"
import script from "./erikoistujien-seuranta-virkailija-card.vue?vue&type=script&lang=ts&"
export * from "./erikoistujien-seuranta-virkailija-card.vue?vue&type=script&lang=ts&"
import style0 from "./erikoistujien-seuranta-virkailija-card.vue?vue&type=style&index=0&id=e7e8897a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e8897a",
  null
  
)

export default component.exports